import { z } from 'zod'

export const ApiKeySchema = z.object({
  partner: z.string().min(3),
  key: z.string(),
  secret_key: z.string(),
})

export type ApiKey = z.infer<typeof ApiKeySchema>

const randomString = (length: number): string => {
  // Our character set
  const alphabet =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  // Get crypto-secure random bytes using Web Crypto API
  const bytes = new Uint8Array(length)
  crypto.getRandomValues(bytes)

  // Map bytes to indices first
  const indices = Array.from(bytes).map(
    (byteValue) => byteValue % alphabet.length,
  )

  // Then map indices to characters
  const chars = indices.map((index) => alphabet.charAt(index))

  // Join the characters into our final string
  return chars.join('')
}

export const newApiKey = (partner: string): ApiKey => {
  //generate a random string of 32 letters and numbers
  const key = 'public_' + randomString(20)
  const secret_key = 'secret_' + randomString(20)
  return ApiKeySchema.parse({
    partner,
    key,
    secret_key,
  })
}

export const RequestUserTokenDto = z.object({
  email: z.string().email(),
  api_key: z.string(),
  api_secret_key: z.string(),
})
